<!--
 * @Description:
 * @version:
 * @Author: sunqian_sr
 * @Date: 2022-11-21 17:19:48
 * @LastEditors: guanbowen 
 * @LastEditTime: 2023-01-31 09:35:21
-->
<template>
  <div v-if="item.isVisible && item.isVisible === 1">
    <template
      v-if="
        hasOneShowingChild(menuInfo, menuInfo.children) && (!onlyOneChild.children || onlyOneChild.noShowingChildren)
      "
    >
      <app-link
        v-if="onlyOneChild.menuName && onlyOneChild.menuType !== 3"
        :to="resolvePath(onlyOneChild.router, onlyOneChild.query)"
      >
        <el-menu-item :index="resolvePath(onlyOneChild.router)" :class="{ 'submenu-title-no-dropdown': !isNest }">
          <!-- 设置除开主目录，子菜单不展示icon -->
          <em v-if="onlyOneChild.icon && hiddenMenuName" :class="['iconfont', onlyOneChild.icon]"></em>
          <span v-if="onlyOneChild.menuName" class="menu-name" slot="title">
            {{ onlyOneChild.menuName }}
          </span>
        </el-menu-item>
      </app-link>
    </template>

    <el-submenu
      v-else
      ref="subMenu"
      :index="resolvePath(menuInfo.router)"
      popper-class="sider-submenu"
      popper-append-to-body
    >
      <template #title>
        <em v-if="menuInfo.icon && hiddenMenuName" :class="['iconfont', menuInfo.icon]"></em>
        <span slot="title" v-if="menuInfo.menuName" class="menu-name">
          {{ menuInfo.menuName }}
        </span>
      </template>
      <sidebar-item
        v-for="child in menuInfo.children"
        :key="child.router"
        :is-nest="true"
        :item="child"
        :base-path="resolvePath(child.router)"
      />
    </el-submenu>
  </div>
</template>
<script>
import { cloneDeep } from '@package/utils'
import path from 'path-browserify'
import AppLink from './Link.vue'

export default {
  name: 'SidebarItem',
  components: { AppLink },
  props: {
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ''
    },
    hiddenMenuName: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      onlyOneChild: null,
      menuInfo: null
    }
  },
  watch: {
    item: {
      handler(val) {
        this.menuInfo = cloneDeep(val)
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    hasOneShowingChild(parent, children = []) {
      // if (!children) {
      //   children = [];
      // }
      const showingChildren = children.filter((item) => {
        if (!item.isVisible && item.isVisible !== 1) {
          return false
        }
        // Temp set(will be used if only has one showing child)
        this.onlyOneChild = item
        return true
      })

      // When there is only one child router, the child router is displayed by default
      if (showingChildren.length === 1) {
        return true
      }

      // Show parent if there are no child router to display
      if (showingChildren.length === 0) {
        this.onlyOneChild = {
          ...parent,
          router: '',
          noShowingChildren: true
        }
        return true
      }

      return false
    },
    resolvePath(routePath, routeQuery) {
      // return routePath
      if (routePath) {
        return routePath
      }
      if (this.basePath) {
        return this.basePath
      }
      if (routeQuery) {
        const query = JSON.parse(routeQuery)
        return {
          path: path.resolve(this.basePath, routePath),
          query
        }
      }
      return path.resolve(this.basePath || '', routePath || '')
    }
  },
  mounted() {
    // console.log('item', this.item)
  }
}
</script>
<style lang="scss" scoped>
.hide-sidebar .submenu-title-no-dropdown {
  width: 50px;
  ::v-deep .el-tooltip{
    padding: 0 10px!important;
    text-align: center;
  }
}
</style>
